export default __webpack_public_path__ + "static/media/large.cadb342c.jpg";